<div class="page">
    <div id="header" class="content-header">
        <app-header-component></app-header-component>    
    </div>

    <div id="content" class="content">
        <router-outlet></router-outlet>
    </div>
    <div id="footer" class="content-footer">
        <app-footer-component></app-footer-component>
    </div>
</div>